module.exports = __webpack_public_path__ + "images/edge-old-4.jpg?a2f36161d39b2cd4fad685d907be361a";